import { CompanyRepository } from "../domain/CompanyRepository";
import { ServiceDelivery } from "../domain/ServiceDelivery";
import { ServiceDeliveryRepository } from "../domain/ServiceDeliveryRepository";

export class SelectCompaniesSD {
    constructor(
        private readonly screen_data,
        private readonly company_repo: CompanyRepository,
        private readonly sd_repo: ServiceDeliveryRepository
    ) {}

    async execute(sd: ServiceDelivery) {
        let comps = await this.company_repo.find_by_user_id(sd.user_id)
        this.screen_data.selectCompanyPopup.set_companies(comps);
        this.screen_data.selectCompanyPopup.set_sd(sd);
        let res = await this.screen_data.selectCompanyPopup.show();
        if (res) {
            let company_ids: number[] = [];
            for (let company of res) {
                company_ids.push(company.id);
            }
            if (sd.credits >= company_ids.length) {
                await this.sd_repo.save(sd.sd_id, company_ids)
            }
        }
    }
}